import { Component, Input, Output, EventEmitter } from '@angular/core';
import { TaskService } from 'src/app/core/service/task.service';
import { MessageHandlerService } from 'src/app/core/utility/message-handler.service';
import { TeamAssignEdit } from '../model/team';
import { merge } from 'lodash';
import { UntypedFormBuilder, Validators } from '@angular/forms';

@Component({
  selector: 'app-team-assign',
  templateUrl: './team-assign.component.html',
  styleUrls: ['./team-assign.component.scss']
})
export class TeamAssignComponent
{
  @Output() public cancelling: EventEmitter<any> = new EventEmitter();
  @Output() public save: EventEmitter<any> = new EventEmitter();

  public teamAssignEdit: TeamAssignEdit;
  public assignForm: any;
  public assignFormActive = false;
  public tasksMember: any[];
  public tasks: any[] = [];

  constructor(
    private fb: UntypedFormBuilder,
    private taskService: TaskService,
    private messageHandlerService: MessageHandlerService
  )
  { }

  @Input() public set model(teamAssign: TeamAssignEdit)
  {
    this.initModel(teamAssign);
  }

  public onSave(e: Event): void
  {
    e.preventDefault();
    const objectToPersist = merge(this.teamAssignEdit, this.assignForm.value);

    this.tasks.forEach(
      taskUser =>
      {
        if (objectToPersist.tasks.filter(t => t.id === taskUser.id).length === 0)
        {
          this.taskService.unAssignTask(taskUser.id).subscribe();
        }
      });
    this.save.emit(objectToPersist);
    this.assignFormActive = false;
  }

  /**
   * Method to indicate if the task is assigned to the user.
   * This is use to set the custom checkbox of the kendo-multiselect.
   *
   * @param filterItem Filter property name
   * @param itemValue Item value id
   */
  public isTaskAssigned(filterItem: string, itemValue: any): boolean
  {
    return this.assignForm.controls[filterItem] && this.assignForm.controls[filterItem].value.find(t => t.id === itemValue) !== undefined;
  }

  public closeAssignForm(): void
  {
    this.assignFormActive = false;
    this.cancelling.emit();
  }

  public onCancel(e: Event): void
  {
    e.preventDefault();
    this.closeAssignForm();
  }

  public addTask(taskId: number): void
  {
    if (this.tasks.find(t => t === taskId) === undefined)
    {
      this.tasks.push(taskId);
    }
  }

  private initModel(teamAssign: TeamAssignEdit)
  {
    this.assignFormActive = teamAssign !== undefined;
    this.tasks = [];
    if (this.assignFormActive)
    {
      // Set form
      this.assignForm = this.fb.group({
        user: [teamAssign.user, Validators.required],
        tasks: [this.tasks, Validators.required],
        member: [teamAssign.member, Validators.required]
      });
      this.taskService.getTasksForMember(teamAssign.member.id).subscribe({
        next: (tasksMember) =>
        {
          this.tasksMember = tasksMember.filter(task => task.status = 'Open');
          this.taskService.getTasksForAssignee(teamAssign.user.username).subscribe({
            next: (tasks) =>
            {
              tasks.forEach(task => this.tasksMember.find(t => t.id === task.id) !== undefined ? this.tasks.push(task) : '');
              this.assignForm.controls.tasks.setValue(this.tasks);
            },
            error: (error) =>
            {
              this.messageHandlerService.displayError(error);
            }
          });
        },
        error: (error) =>
        {
          this.messageHandlerService.displayError(error);
        }
      });
    }
  }
}
